import React from 'react';

const WelcomeScreen = ({
  currentContext,
  sampleQuestions,
  inputMessage,
  onInputChange,
  onSubmit,
  onQuestionSelect,
  isTyping,
  displayName,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    if (isTyping || !inputMessage.trim()) return;
    onSubmit();
  };

  return (
    <div className="w-full max-w-3xl mx-auto text-center space-y-3 px-6">
      <h1 className="text-2xl text-gray-900 text-left">
       Ask
      </h1>

      {currentContext && (
        <div className="mx-auto max-w-2xl border border-blue-200 bg-blue-50 p-2 text-left">
          <p className="mb-1 text-sm text-blue-800">Context applied</p>
          <p className="text-sm text-blue-700">
            {currentContext.contextType === "filtered_chat"
              ? "Custom filters applied"
              : currentContext.description || "Analysis context ready"}
          </p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="w-full">
        <div className="flex w-full items-center border border-gray-300 bg-white px-4 py-2 shadow-sm">
          <input
            value={inputMessage}
            onChange={(event) => onInputChange(event.target.value)}
            placeholder="Ask question about rock tools reports"
            className="flex-1 border-none text-base text-gray-900 placeholder-gray-500 focus:outline-none"
            disabled={isTyping}
          />
          <button
            type="submit"
            disabled={isTyping || !inputMessage.trim()}
            className="ml-3 bg-gray-300 px-5 py-2 text-sm text-black transition-colors hover:bg-gray-400 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
          >
            Send
          </button>
        </div>
      </form>

      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 pt-1">
        {sampleQuestions.slice(0, 4).map((question, index) => (
          <button
            key={index}
            onClick={() => onQuestionSelect(question)}
            disabled={isTyping}
            className="text-left border border-gray-300 bg-white p-3 text-sm transition-colors hover:border-electric-blue hover:bg-gray-100 disabled:opacity-60"
          >
            <div className=" text-gray-900">{question}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default WelcomeScreen;